import React from 'react';
import ExchangeMediumFormPage from 'pages/Configuration/ConfigurationViews/ConfigurationWidget/WidgetsForms/Exchange/ExchangeMedium';
import * as Yup from 'yup';
import WidgetForm from '../WidgetForm';
import { useSelector } from 'react-redux';
import useFirebase from '../../../../hooks/Firebase/useFirebase';
import { toast } from 'react-toastify';

const EMForm = {
    stock: {
        name: "stock",
        placeholder: "Symbol (ex: AAPL)",
        label: "Symbol",
        required: true
    },
    timer: {
        name: "timer",
        placeholder: "Timer (ms)",
        label: "Refresh timer",
        required: true
    }
}

const EMValidate = Yup.object().shape({
    [EMForm.stock.name]: Yup.string().required("Required"),
    [EMForm.timer.name]: Yup.number().required("Required"),
})

const ExchangeMediumForm = (props) => {
    const [, addElement] = useFirebase()
    const [EMInitial, setEMInitial] = React.useState({
        [EMForm.stock.name]: "",
        [EMForm.timer.name]: "",
    })
    const {widgets} = useSelector(state => state.widgets);

    React.useEffect(() => {
        if (props.widget) {
            setEMInitial(props.widget);
        }
    }, [props.widget])

    const handleSubmit = (values, formikBag) => {
        if (props.handleEdit) {
            props.handleEdit(values);
            const valuesParsed = widgets?.map(el => {
                if (el.id === props.widgetID) {
                    return {
                        ...el.widget,
                        ...values,
                    };
                }
                return el.widget;
            })
            addElement.setWidget("users", valuesParsed)
            toast("The widget was updated !");
            return
        }
        addElement.widget("users", {
            service_id: props.serviceSelected.id,
            widget_id: props.widgetSelected.id,
            timer: values[EMForm.timer.name],
            stock: values[EMForm.stock.name]
        });

        formikBag.resetForm()
        toast("The widget was added to your dashboard !");
    }

    return (
        <WidgetForm WForm={EMForm} WInitial={EMInitial} WValidate={EMValidate} handleSubmit={handleSubmit}>
            <ExchangeMediumFormPage handleEdit={props.handleEdit} />
        </WidgetForm>
    );
};

export default ExchangeMediumForm;